import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';
import ReactTable from "react-table";
import "react-table/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";

import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';


import matchSorter from "match-sorter";

import '../styles/sideProfile.scss';
import profileIcon from '../img/profile.png';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class DashboardBuyer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.showSellerList = this.showSellerList.bind(this);
        this.showRegion = this.showRegion.bind(this);
    }

    componentDidMount() {
        this.showSellerList();
        this.showRegion();
    }

    showSellerList(){
        let that = this; //this는 dashboardBuyer component!
        // console.log("this state is what??",this);
        axios.get('https://spice-api.pearlfall.vercel.app'+`/users/buyer/dashboard`, this.state)
            .then(function (response) {
                // console.log('response seller list', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    data: response.data,
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    showRegion(){
        // let that = this; //this는 dashboardBuyer component!
        // axios.get('https://spice-api.pearlfall.now.sh'+`/users/getUser`, this.state)
        //     .then(function (response) {
        //         console.log('response region', response);
        //         that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
        //             //따라서 that에 this를 저장해서 여기서 불러야함
        //             region: response.data.region,
        //         });
        //         console.log("region", that.state.region);
        //     })
        //     .catch(function (error) {
        //         console.log(error);
        //     })
    }

//     render() {
//         return (
//             <div className="profile-right">
//
//                 <h1 className="text-center dashboard-title">
//                     Here are some sellers in <span style={{"font-weight": "600"}}>{this.props.user.region}!</span>
//                 </h1>
//                 <Row>
//                     <Col md={1}></Col>
//                     <Col md={10}>
//                         <ReactTable style={{"marginTop":"2rem"}}
//                             data={this.state.data}
//                             filterable
//                             defaultFilterMethod={(filter, row) =>
//                                 String(row[filter.id]) === filter.value}
//                             columns={[
//                                 {
//                                     // Header: () => (
//                                     //     <div className="table-header">Seller Name</div>
//                                     // ),
//                                     // Header: () => {
//                                     //     return(
//                                     //         <div className="table-header">Seller Name</div>
//                                     //     );
//                                     // },
//                                     // Header: "Seller Name",
//                                     Header: () => {
//                                         return(
//                                             <div
//                                                 style={{
//                                                     backgroundColor: "lightblue",
//                                                     // position: "absolute",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     top: "0px",
//                                                     left: "0px",
//                                                     alignItems: "center",
//                                                     fontWeight: "bold",
//                                                     fontFamily: "Recoleta",
//                                                     fontSize: "1.5rem",
//                                                     display: "flex",
//                                                     justifyContent: "center",
//
//                                                 }}
//                                             >
//                                                 Seller Name
//                                             </div>
//                                         );
//                                     },
//                                     accessor: "username",
//                                     width: 150,
//                                     sortable: true,
//                                     filterAll: true,
//                                     filterMethod: (filter, rows) =>
//                                         matchSorter(rows, filter.value, {keys: [filter.id]}),
//                                     Cell: (data) => {
//                                         return (
//                                             <div className="text-center">
//                                                 <Link
//                                                     // className="btn btn-sm btn-outline-secondary m-0"
//                                                     style={{"color": "orange", "font-weight": "bold"}}
//                                                     to = {'/dashboard/profile/'+data.row.username}
//                                                 >
//                                                     {data.row.username}
//                                                 </Link>
//                                             </div>
//                                         );
//                                     }
//
//                                 },
//                                 {
//                                     // Header: "Talent",
//                                     Header: () => {
//                                         return(
//                                             <div
//                                                 style={{
//                                                     backgroundColor: "lightpink",
//                                                     // position: "absolute",
//                                                     // width: "100%",
//                                                     // height: "100%",
//                                                     top: "0px",
//                                                     left: "0px",
//                                                     alignItems: "center",
//                                                     fontWeight: "bold",
//                                                     fontFamily: "Recoleta",
//                                                     fontSize: "1.5rem",
//                                                     display: "flex",
//                                                     justifyContent: "center",
//
//                                                 }}
//                                             >
//                                                 Topic
//                                             </div>
//                                         );
//                                     },
//                                     accessor: "topic",
//                                     width: 120,
//                                     sortable: true,
//                                     filterAll: true,
//                                     filterMethod: (filter, rows) =>
//                                         matchSorter(rows, filter.value, {keys: [filter.id]}),
//
//                                 },
//                                 {
//                                     // Header: "Description",
//                                     // Header: () => {
//                                     //     return(
//                                     //         <div
//                                     //             style={{
//                                     //                 backgroundColor: "lightgreen",
//                                     //                 position: "absolute",
//                                     //                 width: "100%",
//                                     //                 height: "100%",
//                                     //                 top: "0px",
//                                     //                 left: "0px",
//                                     //                 alignItems: "center",
//                                     //                 fontWeight: "bold",
//                                     //                 fontFamily: "Recoleta",
//                                     //                 display: "flex",
//                                     //                 justifyContent: "center",
//                                     //
//                                     //             }}
//                                     //         >
//                                     //             Description
//                                     //         </div>
//                                     //     );
//                                     // },
//                                     Header: () => {
//                                         return(
//                                             <div
//                                                 style={{
//                                                     backgroundColor: "lightgreen",
//                                                     // backgroundSize: "cover",
//                                                     // position: "relative",
//                                                     width: "100%",
//                                                     height: "100%",
//                                                     top: "0px",
//                                                     left: "0px",
//                                                     alignItems: "center",
//                                                     fontWeight: "bold",
//                                                     fontFamily: "Recoleta",
//                                                     fontSize: "1.5rem",
//                                                     display: "flex",
//                                                     justifyContent: "center",
//                                                     // fontSize: "5rem"
//                                                     // margin: "1rem auto"
//                                                     // padding: "10px"
//                                                 }}
//                                             >
//                                                 Description
//                                             </div>
//                                         );
//                                     },
//                                     accessor: "description",
//                                     width: 500,
//                                     filterAll: false,
//                                 },
//                                 // {
//                                 //     // Header: "Detail",
//                                 //     //
//                                 //
//                                 // }
//                                 //     id: 'Detail',
//                                 //     // accessor: 'topic',
//                                 //     width: 85,
//                                 //     filterable: false,
//                                 //     Cell: (data) => {
//                                 //         return (
//                                 //             <div className="text-center">
//                                 //                 <Link
//                                 //                     className="btn btn-sm btn-outline-secondary m-0"
//                                 //                     to = {'/dashboard/profile/'+data.row.username}
//                                 //                 >
//                                 //                     <img src={profileIcon} className="profile-icon"/>
//                                 //                 </Link>
//                                 //             </div>
//                                 //         );
//                                 //     }
//                                 // },
//
//                             ]}
//                             defaultPageSize={5}
//                             className="-striped -highlight"
//                         />
//                     </Col>
//                     <Col md={1}></Col>
//                 </Row>
//             </div>
//         );
//     }
// }
    render() {
        return (
            <div className="profile-right">

                <h1 className="text-center dashboard-title">
                    Here are some sellers in <span style={{"font-weight": "600"}}>{this.props.user.region}!</span>
                </h1>
                <Row>
                    <Col md={1}></Col>
                    <Col md={10}>
                        <ReactTableFixedColumns style={{"marginTop":"2rem"}}
                                    data={this.state.data}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                    columns={[
                                        {
                                            // Header: () => (
                                            //     <div className="table-header">Seller Name</div>
                                            // ),
                                            // Header: () => {
                                            //     return(
                                            //         <div className="table-header">Seller Name</div>
                                            //     );
                                            // },
                                            // Header: "Seller Name",
                                            Header: () => {
                                                return(
                                                    <div
                                                        style={{
                                                            backgroundColor: "lightblue",
                                                            // position: "absolute",
                                                            width: "100%",
                                                            height: "100%",
                                                            top: "0px",
                                                            left: "0px",
                                                            alignItems: "center",
                                                            fontWeight: "bold",
                                                            fontFamily: "Recoleta",
                                                            fontSize: "1.2rem",
                                                            display: "flex",
                                                            justifyContent: "center",

                                                        }}
                                                    >
                                                        Seller Name
                                                    </div>
                                                );
                                            },
                                            fixed: "left",
                                            accessor: "username",
                                            width: 130,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),
                                            Cell: (data) => {
                                                return (
                                                    <div className="text-center">
                                                        <Link
                                                            // className="btn btn-sm btn-outline-secondary m-0"
                                                            style={{"color": "orange", "font-weight": "bold"}}
                                                            to = {'/dashboard/profile/'+data.row.username}
                                                        >
                                                            {data.row.username}
                                                        </Link>
                                                    </div>
                                                );
                                            }

                                        },
                                        {
                                            // Header: "Talent",
                                            Header: () => {
                                                return(
                                                    <div
                                                        style={{
                                                            backgroundColor: "lightpink",
                                                            // position: "absolute",
                                                            // width: "100%",
                                                            // height: "100%",
                                                            top: "0px",
                                                            left: "0px",
                                                            alignItems: "center",
                                                            fontWeight: "bold",
                                                            fontFamily: "Recoleta",
                                                            fontSize: "1.2rem",
                                                            display: "flex",
                                                            justifyContent: "center",

                                                        }}
                                                    >
                                                        Topic
                                                    </div>
                                                );
                                            },
                                            accessor: "topic",
                                            width: 90,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),

                                        },
                                        {
                                            // Header: "Description",
                                            // Header: () => {
                                            //     return(
                                            //         <div
                                            //             style={{
                                            //                 backgroundColor: "lightgreen",
                                            //                 position: "absolute",
                                            //                 width: "100%",
                                            //                 height: "100%",
                                            //                 top: "0px",
                                            //                 left: "0px",
                                            //                 alignItems: "center",
                                            //                 fontWeight: "bold",
                                            //                 fontFamily: "Recoleta",
                                            //                 display: "flex",
                                            //                 justifyContent: "center",
                                            //
                                            //             }}
                                            //         >
                                            //             Description
                                            //         </div>
                                            //     );
                                            // },
                                            Header: () => {
                                                return(
                                                    <div
                                                        style={{
                                                            backgroundColor: "lightgreen",
                                                            // backgroundSize: "cover",
                                                            // position: "relative",
                                                            width: "100%",
                                                            height: "100%",
                                                            top: "0px",
                                                            left: "0px",
                                                            alignItems: "center",
                                                            fontWeight: "bold",
                                                            fontFamily: "Recoleta",
                                                            fontSize: "1.2rem",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            // fontSize: "5rem"
                                                            // margin: "1rem auto"
                                                            // padding: "10px"
                                                        }}
                                                    >
                                                        Description
                                                    </div>
                                                );
                                            },
                                            accessor: "description",
                                            // width: "100%",
                                            filterAll: false,
                                        },
                                        // {
                                        //     // Header: "Detail",
                                        //     //
                                        //
                                        // }
                                        //     id: 'Detail',
                                        //     // accessor: 'topic',
                                        //     width: 85,
                                        //     filterable: false,
                                        //     Cell: (data) => {
                                        //         return (
                                        //             <div className="text-center">
                                        //                 <Link
                                        //                     className="btn btn-sm btn-outline-secondary m-0"
                                        //                     to = {'/dashboard/profile/'+data.row.username}
                                        //                 >
                                        //                     <img src={profileIcon} className="profile-icon"/>
                                        //                 </Link>
                                        //             </div>
                                        //         );
                                        //     }
                                        // },

                                    ]}
                                    defaultPageSize={5}
                                    className="-striped -highlight "
                        />
                    </Col>
                    <Col md={1}></Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user
    };
}


export default withTracker(withRouter(connect(mapStateToProps)(DashboardBuyer)));
